import { Outlet } from 'react-router-dom';

import CreditCreatePage from '@/pages/dashboard/billing/billing-credit-create';
import MarketplacePage from '@/pages/dashboard/marketplace/marketplace.page';
import PackageDetail from '@/pages/dashboard/marketplace/package-detail.page';
import PackageTransactions from '@/pages/dashboard/marketplace/package-transactions';
import PackageVersionList from '@/pages/dashboard/marketplace/package-version-list';
import MarketPlacePayment from '@/pages/dashboard/marketplace/payment.page';
import PaymentVerify from '@/pages/dashboard/marketplace/PaymentVerify';
import RoadMapPage from '@/pages/dashboard/RoadMap';

import FixNavigate from '../components/common/FixNavigate';
import PrivateRoute from '../components/common/PrivateRoute';
import McBotFaceEditor from '../features/bot/McBotFaceEditor';
import DashboardLayout from '../layout/dashboard.layout';
import BillingPage from '../pages/dashboard/billing/billing.page';
import BillingCheckInPage from '../pages/dashboard/billing/billing-checkin.page';
import BillingCheckoutPage from '../pages/dashboard/billing/billing-checkout.page';
import BillingCreatePage from '../pages/dashboard/billing/billing-create';
import ChatbotEdit from '../pages/dashboard/ChatbotEdit';
import ContactUs from '../pages/dashboard/ContactUs';
import Dashboard from '../pages/dashboard/home/Dashboard';
import KnowledgeBasesPage from '../pages/dashboard/knowledge-bases/knowledge-bases.page';
import PartnerPage from '../pages/dashboard/partner/partnerPanel';
import ProfilePage from '../pages/dashboard/profile/profile.page';
import ProfileChangeEmail from '../pages/dashboard/profile/profile-change-email/profile-change-email.page';
import ProfileChangePassword from '../pages/dashboard/profile/profile-change-password/profile-change-password';
import ProfileEditPage from '../pages/dashboard/profile/profile-edit/profile-edit.page';
import ProfileInfoEditPage from '../pages/dashboard/profile/profile-info-edit/profile-info-edit.page';
import RewardsPage from '../pages/dashboard/rewards/RewardsPage';
import SettingTempPage from '../pages/dashboard/setting.page';
import PlanVerify from '../pages/PlanVerify';
import ErrorPage from '../pages/site/ErrorPage';

const DashboardRouterChildren = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'profile-edit/:name',
        element: <ProfileEditPage />,
      },
      {
        path: 'profile-info-edit',
        element: <ProfileInfoEditPage showModal={true} />,
      },
      {
        path: 'profile-change-email',
        element: <ProfileChangeEmail />,
      },
      {
        path: 'profile-change-password',
        element: <ProfileChangePassword showModal={true} />,
      },
      {
        path: 'chatbots',
        children: [
          {
            index: true,
            element: <KnowledgeBasesPage type="widget" />,
          },
          {
            path: 'editor',
            element: <McBotFaceEditor />,
          },
        ],
      },
      {
        path: 'chatbot-edit',
        children: [
          {
            index: true,
            element: <ChatbotEdit />,
          },
        ],
      },
      {
        path: 'human-clones',
        element: <KnowledgeBasesPage type="link" />,
      },
      {
        path: 'billing',
        element: <BillingPage />,
      },
      {
        path: 'billing-create',
        element: <BillingCreatePage />,
      },
      {
        path: 'billing-checkout',
        element: <BillingCheckoutPage />,
      },
      {
        path: 'billing-checkin',
        element: <BillingCheckInPage />,
      },
      {
        path: 'billing-credit-create',
        element: <CreditCreatePage />,
      },

      {
        path: 'setting',
        element: <SettingTempPage />,
      },
      {
        path: 'road-map',
        element: <RoadMapPage />,
      },

      {
        path: 'contact',
        element: <ContactUs />,
      },
      {
        path: 'rewards',
        element: <RewardsPage />,
      },
      {
        path: 'business-partner-panel',
        element: <PartnerPage />,
      },
      {
        path: 'marketplace',
        children: [
          {
            index: true,
            element: <MarketplacePage />,
          },
          {
            path: 'version-list',
            element: <PackageVersionList />,
          },
          {
            path: 'detail',
            element: <PackageDetail />,
          },
          {
            path: 'transactions',
            element: <PackageTransactions />,
          },
          {
            path: 'payment',
            element: <MarketPlacePayment />,
          },
        ],
      },
      {
        path: 'verify-payment',
        element: <PaymentVerify />,
      },
    ],
  },
];

const DashboardRouter = [
  {
    path: '/en-US/control-panel',
    element: (
      <PrivateRoute>
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: DashboardRouterChildren,
  },
  {
    path: '/fr-FR/control-panel',
    element: (
      <PrivateRoute>
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: DashboardRouterChildren,
  },
  {
    path: '/en-US/verify-plan',
    element: (
      <PrivateRoute>
        <PlanVerify />
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: DashboardRouterChildren,
  },
  {
    path: '/fr-FR/verify-plan',
    element: (
      <PrivateRoute>
        <PlanVerify />
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: DashboardRouterChildren,
  },
  {
    path: '/verify-plan',
    element: <FixNavigate to={`/verify-plan${window.location.search}`} />,
    errorElement: <ErrorPage />,
    children: DashboardRouterChildren,
  },
  {
    path: '/control-panel',
    element: <FixNavigate to={'/control-panel'} />,
    errorElement: <ErrorPage />,
  },
];

export default DashboardRouter;
